import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/features/auth/store/auth-store";

/**
 * Gates the vendor Control Center (`/admin/*`) to platform admins only. A firm
 * admin or member (or any non-platform-admin) is bounced to the dashboard —
 * the server independently enforces `IsPlatformAdmin` on every write, so this is
 * a UX guard, not the security boundary.
 */
export function PlatformAdminRoute() {
  const isPlatformAdmin = useAuthStore((s) => s.user?.is_platform_admin ?? false);

  if (!isPlatformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
